import React from 'react';
import { Table, message, Button, Icon, Input, Row, Col, Divider, Avatar, Statistic } from 'antd';
import { orderClientQuotaAc as AC } from '../../../redux/actions';
import { connect } from 'react-redux';
import SearchRender from './SearchRender';
import { download2 } from "../../../utils";
import moment from "moment";

function RenderBase({ appRd, store, set, get, getxls }) {
	const { data, dataLoading, dataFetchProps, searchProps, selectedRow, selectedRowIndex, pagination } = store;

	if (dataLoading) {
		get({ ...dataFetchProps, ...searchProps });
	}

	const refreshData = async () => {
		let msg = await get({ ...dataFetchProps, ...searchProps });
		message.info(msg);
	}

	const columns = [
		{ title: 'id', dataIndex: 'id', key: 'id', className: 'align_center', width: 50 },
		{ title: '客户编码', dataIndex: 'sap_no', key: 'sap_no', width: 90 },
		{
			title: '业务员',
			dataIndex: 'bizperson',
			key: 'bizperson',
			render: (text) => (
				<div>
					{text ? (
						<span>
               <Avatar size="small" style={{ marginRight: 8, backgroundColor: '#69c0ff', color: '#fff' }}>
  {text.charAt(0)}
</Avatar>
              <Statistic value={text} valueStyle={{ fontSize: '15px', fontWeight: 'bold' }} />
            </span>
					) : (
						''
					)}
				</div>
			),
			width: 80,
		},{
			title: '产品模式',
			dataIndex: 'guarantee_type',
			key: 'guarantee_type',
			width: 120,
			render: (text, record) => (
				<div>
					{text !== undefined && text !== null ? (
						<span>
          <Avatar size="small" style={{ marginRight: 8 }}>
            {text === 0 ? '企' : text === 1 ? '大' : ''}
          </Avatar>
          <span style={{ fontSize: '14px', fontWeight: 'normal', color: text === 0 ? '#1890ff' : text === 1 ? '#00bcd4' : 'inherit' }}>
            {text === 0 ? '企信宝' : text === 1 ? '大经宝' : ''}
          </span>
        </span>
					) : (
						''
					)}
				</div>
			),
		},
		{ title: '客户名称', dataIndex: 'cust_name', key: 'cust_name', width: 150 },
		{ title: '分公司', dataIndex: 'subcompany', key: 'subcompany', width: 100 },
		{ title: '授信金额', dataIndex: 'loan_credit', key: 'loan_credit', sorter: (a, b) => a.loan_credit - b.loan_credit, width: 110 },
		{
			title: '放款金额',
			dataIndex: 'loan_amount',
			key: 'loan_amount',
			sorter: (a, b) => a.loan_amount - b.loan_amount,
			render: (text) => parseFloat(text).toFixed(2),
			width:110
		},
		{
			title: '占用额度',
			dataIndex: 'use_amount',
			key: 'use_amount',
			sorter: (a, b) => a.use_amount - b.use_amount,
			render: (text) => (
				<div>
					{text ? <span><Statistic value={text} precision={2} valueStyle={{ fontSize: '15px', fontWeight: 'bold', color: '#E9967A' }} /></span> : ''}
				</div>
			),
			width: 100,
		},
		{
			title: '可用额度',
			dataIndex: 'usable_amount',
			key: 'usable_amount',
			sorter: (a, b) => a.usable_amount - b.usable_amount,
			render: (text) => (
				<div>
					{text ? <span><Statistic value={text} precision={2} valueStyle={{ fontSize: '15px', fontWeight: 'bold', color: '#228B22' }} /></span> : ''}
				</div>
			),
			width: 120,
		},
		{ title: '首次支付时间', dataIndex: 'pay_time', key: 'pay_time', render: (text) => (text ? moment(text).format('YYYY-MM-DD HH:mm') : null), width: 120 },
		{ title: '授信到期时间', dataIndex: 'finished_at', key: 'finished_at', render: (text) => (text ? moment(text).format('YYYY-MM-DD HH:mm') : null), width: 120 },
	];

	const tableDefinition = {
		rowKey: 'id',
		loading: dataLoading,
		pagination: pagination,
		size: 'small',
		columns: columns,
		dataSource: data,
		scroll: { x: 800, y: window.innerHeight - 370 },
		onRow: (record, index) => ({ onClick: (event) => set({ selectedRow: record, selectedRowIndex: index }) }),
		rowClassName: (record, index) => (index === selectedRowIndex ? 'selectedItem' : ''),
	};

	const BtnHandle = async (e) => {
		if (e.target.name === 'download') {
			let hrefUrl = await getxls();
			download2(hrefUrl, '');
		}
	}

	const formRenderProps = {
		onFinish(data) {
			// 1  先清空分页中原有的当前页，pagination.current =1
			// 2 将搜索内容更新到 searchProps内。
			// 3 更新dataLoading 为true。

			let paginationNew = { ...pagination }
			paginationNew.current = 1;

			set({ dataLoading: true, pagination: { ...paginationNew }, searchProps: data });
		}

	}
	pagination.onChange = (page, pageSize) => {
		if (isNaN(pageSize)) {
			//这是异常刷新，不记录任何值,比如排序刷新
			return;
		}
		let paginationNew = { ...pagination };
		paginationNew.current = page;  //如果page是1，直接提交即可
		paginationNew.pageSize = pageSize;
		set({ pagination: paginationNew, dataLoading: true });

	}

	pagination.onShowSizeChange = (current, size) => {
		let paginationNew = { ...pagination };
		let overcount = paginationNew.pageSize * (paginationNew.current - 1);

		paginationNew.current = 1 + parseInt(overcount / size);

		paginationNew.pageSize = size;
		set({ pagination: paginationNew, dataLoading: true });

	}

	return (
		<div>
			<Row style={{ marginBottom: 10 }}>
				<Col span={24}><Input.Group compact size="large">
					<Button onClick={refreshData}  > <Icon type="sync" style={{ color: 'green' }} />刷新</Button>
					<Divider type={"vertical"} />
					<Button type='primary' onClick={BtnHandle} name='download'><Icon type="file-excel" />导出</Button>
				</Input.Group>
				</Col>
			</Row>
			<Row>
				<Col span={24}>
					<SearchRender {...formRenderProps} />
				</Col>
			</Row>
			<Table {...tableDefinition} />
		</div>);
}

const mapStateToProps = (state) => {
	return {
		store: state.orderClientQuotaRd,
		appRd: state.appReducer
	}
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		set: (value) => dispatch(AC.SET(value)),
		get: (value) => dispatch(AC.GET(value)),
		getxls: (value) => dispatch(AC.GETXLS(value)),
	}
}

const clientQuota = connect(mapStateToProps, mapDispatchToProps)(RenderBase);

export default clientQuota;
